module.exports = __webpack_public_path__ + "img/twocan-list-screens.59972711.png";